import { shape_ellipse } from "./drawing-shapes";
import { DrawShapeBaseAdvancedModule } from "../../ModuleBase/shape-base-advanced-module";

export class DrawShapesElpsModule extends DrawShapeBaseAdvancedModule {
	constructor(canvas, getColor, drawingHistory) {
		super(canvas, getColor, drawingHistory);

		this.name = "elps";
		this.icon = shape_ellipse;

		this._getInitialShape = pointer => {
			return new fabric.Ellipse({
				left: pointer.x,
				top: pointer.y,
				rx: 1,
				ry: 1,
				fill: this.transpColor,
				strokeWidth: 2,
				stroke: this.__getColor(),
				selectable: false
			})
		}

		this._resizeShape = (e) => {
			const pointer = this.canvas.getPointer(e);
			const diffX = (pointer.x - this.startPosition.x);
			const diffY = (pointer.y - this.startPosition.y);
			let left, top, width = Math.abs(diffX), height = Math.abs(diffY), side = (width + height) / 2;
			if (diffX >= 0 && diffY >= 0) {
				// left top -> right bottom
				left = this.startPosition.x;
				top = this.startPosition.y;
				if (e.shiftKey) {
					width = height = side;
				}
			} else if (diffX < 0 && diffY < 0) {
				// right bottom -> left top
				if (e.shiftKey) {
					left = this.startPosition.x - side;
					top = this.startPosition.y - side;
					width = height = side;
				} else {
					left = pointer.x;
					top = pointer.y;
				}
			} else if (diffX < 0) {
				// right top -> left bottom
				if (e.shiftKey) {
					left = this.startPosition.x - side;
					top = this.startPosition.y;
					width = height = side;
				} else {
					left = pointer.x;
					top = this.startPosition.y;
				}
			} else if (diffY < 0) {
				// left bottom -> right top
				if (e.shiftKey) {
					left = this.startPosition.x;
					top = this.startPosition.y - side;
					width = height = side;
				} else {
					left = this.startPosition.x;
					top = pointer.y;
				}
			}
			let rx = width / 2, ry = height / 2;
			this.shape.set({ left, top, width, height, rx, ry });
		}
	}
}

window.customElements.define(
	"inspx-draw-shapes-elps-module",
	DrawShapesElpsModule
);
